<div class="container-fluid d-flex flex-column p-3 prada-light-gray-bg">
  <p-carousel [value]="news"
    [numVisible]="3"
    [numScroll]="3"
    [circular]="false"
    styleClass="carousel-news"
    [responsiveOptions]="responsiveOptions">
    <ng-template let-news
      pTemplate="item">
      <mat-card class="h-100 mat-elevation-z0"
        (click)="newsClick.emit(news)">
        <mat-card-content>
          <div class="w-100 text-center border-bottom">
            <h2 class="mb-1">
              {{news.title}}
            </h2>
          </div>
          <div class="p-2 pt-3">
            <div [innerHTML]="news.formattedBody | bitfSafeHtml"
              class="news-body"></div>
          </div>
        </mat-card-content>
      </mat-card>
    </ng-template>
  </p-carousel>
</div>